import { useCallback } from 'react';

import { observer } from 'mobx-react';

import gcCrownIcon from '../../../../assets/missions/gcCrown.png';
import scCrownIcon from '../../../../assets/missions/scCrown.png';
import { useStores } from '../../../../stores/useStores';
import type { UpcomingMissionWidgetData, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { UpcomingMissionWidgetTimer } from './UpcomingMissionWidgetTimer/UpcomingMissionWidgetTimer';

interface UpcomingMissionWidgetProps {
  sizeType: WidgetSizeType;
  data: UpcomingMissionWidgetData;
}

function UpcomingMissionWidgetComponent(props: UpcomingMissionWidgetProps) {
  const { sizeType } = props;
  const { missionsStore, coinTypeStore } = useStores();

  const handleClick = useCallback(() => {
    void missionsStore.openDialog();
  }, [missionsStore]);

  const timer = <UpcomingMissionWidgetTimer extended={sizeType === 'wide'} />;

  const widgetImageUrl = coinTypeStore.coinType === 'SC' ? scCrownIcon : gcCrownIcon;

  return (
    <WidgetWrapper smallWidgetExtended sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const UpcomingMissionWidget = observer(UpcomingMissionWidgetComponent);
